export default function Footer() {
  return (
    <footer className="relative bg-background-100/70 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
          <div className="flex-1 lg:max-w-sm">
            <a href="#home" className="flex items-center gap-2.5 mb-4 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-extrabold text-foreground-950">吃瓜投稿</span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed">
              一个给「手里有料不敢实名」的人准备的匿名通道。吃瓜投稿接收爆料、曝光与内幕线索，
              保护隐私同时让瓜见光，合作与递料请走匿名规则。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 flex-[2]">
            <div className="flex flex-col gap-3">
              <h4 className="text-sm font-semibold text-foreground-900 mb-1">看瓜</h4>
              <a href="#feed" className="text-sm text-foreground-600 hover:text-primary-600">今日瓜榜</a>
              <a href="#insider" className="text-sm text-foreground-600 hover:text-primary-600">内幕线索</a>
              <a href="#discussion" className="text-sm text-foreground-600 hover:text-primary-600">爆料热议</a>
            </div>
            <div className="flex flex-col gap-3">
              <h4 className="text-sm font-semibold text-foreground-900 mb-1">投稿</h4>
              <a href="#submit" className="text-sm text-foreground-600 hover:text-primary-600">匿名投递</a>
              <a href="#steps" className="text-sm text-foreground-600 hover:text-primary-600">投稿规则</a>
              <a href="#submit" className="text-sm text-foreground-600 hover:text-primary-600">合作对接</a>
            </div>
            <div className="flex flex-col gap-3">
              <h4 className="text-sm font-semibold text-foreground-900 mb-1">通道</h4>
              <span className="text-sm text-foreground-600">线索：线索@chigua投稿.com</span>
              <span className="text-sm text-foreground-600">合作：bd@chigua投稿.com</span>
              <span className="text-sm text-foreground-600">实时反馈入口，人工回看</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 吃瓜投稿 · 本站内容仅作资讯展示，页面未接入真实投稿与登录接口。
          </p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <a href="#home" className="hover:text-primary-600 whitespace-nowrap">首页</a>
            <a href="#steps" className="hover:text-primary-600 whitespace-nowrap">投稿规则</a>
            <a href="#submit" className="hover:text-primary-600 whitespace-nowrap">免责说明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}